import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageDiscountLookupComponent } from './manage-discount-lookup.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: ManageDiscountLookupComponent, data: { title: 'Discount Lookup' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageDiscountLookupRoutingModule {}

@NgModule({
  imports: [
    ManageDiscountLookupRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [ManageDiscountLookupComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageDiscountLookupModule {}
